<template>
  <div style="width: 100%">
    <vxe-table border auto-resize resizable show-overflow keep-source :data="tableData">
      <!-- <vxe-table-column type="seq" title="序号" width="60"></vxe-table-column> -->
      <vxe-table-column type="expand" title="合计" width="60">
        <template #content="{ row }">
          <ExpandTable
            :fetchTableData="row.fundCollectionOrderList"
            :dateStart="row.dateStart"
            :dateEnd="row.dateEnd"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column
        v-for="(item, index) of tableColumn"
        :key="index"
        :field="item.field"
        :title="item.title"
        :edit-render="item.itemRender"
        :minWidth="item.width"
      >
        <template v-slot="{ row }">
          <span v-if="item.field == 'payService'">
            {{
              dictListMap?.warehouseContractGuizhongLoadExpenseList.find(
                (item) => item.value == row['payService']
              )?.label
            }}
          </span>
          <span v-else>{{ row[item.field] }}</span>
        </template>
      </vxe-table-column>
    </vxe-table>
  </div>
</template>

<script>
  import ExpandTable from './ExpandTable';
  export default {
    name: 'HistoryExecuteTable',
    props: {
      fetchTableData: {
        type: Array,
        default: () => [],
      },
    },
    data() {
      return {
        tableColumn: [
          {
            title: '收费项目',
            field: 'payService',
            width: 150,
          },
          {
            title: '总金额',
            field: 'totalAmount',
            width: 150,
          },
          {
            title: '已收款金额',
            field: 'receivedAmount',
            width: 150,
          },
          {
            title: '未收款金额',
            field: 'unPaymentAmount',
            width: 250,
          },
        ],
        tableData: [],
      };
    },
    components: {
      ExpandTable,
    },
    watch: {
      fetchTableData: {
        handler(val) {
          if (val && Object.keys(val).length) {
            this.tableData = val.map((item) => {
              return {
                ...item,
                unPaymentAmount: item.totalAmount - item.receivedAmount,
              };
            });
            // console.log("this.tableData",this.tableData)
            // const unPaymentAmount = val[0].totalAmount - val[0].receivedAmount;

            // this.tableData[0].unPaymentAmount = unPaymentAmount ? unPaymentAmount : null;
          }
        },
        immediate: true,
      },
    },
  };
</script>

<style lang="scss" scoped></style>
